import { render } from "./LoadingBar.vue?vue&type=template&id=f9fbfba4&scoped=true"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"

import "./LoadingBar.vue?vue&type=style&index=0&id=f9fbfba4&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fbfba4"]])

export default __exports__